<!-- 🔴 ALL ORIGINAL ANGULARJS STRUCTURE COMMENTED OUT LINE BY LINE (SuperPrompt V8) -->
<!-- <div class="modal-header"> -->
<!--   <h3 class="modal-title"> Request JSON <i ng-click="ctrl.cancel()" class="fa fa-times pull-right"></i> -->
<!--     <i class="fa pull-right" ng-class="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px" ng-click="minimise=!minimise"></i> -->
<!--   </h3> -->
<!-- </div> -->
<!-- <div class="modal-body" uib-collapse="minimise"> -->
<!--   <div class="jsonLoader" modal-loader loading="ctrl.showJsonLoader"></div> -->
<!--   <div class="container-border"> -->
<!--     <div class="row"> -->
<!--       <div class="col-md-12"> -->
<!--         <div ng-if="ctrl.showJSON" style="height: 100%;"> -->
<!--           <div class="old old_diff_block">JSON Data </div> -->
<!--           <div class="jsonContainer" style="height: 100%; overflow: auto;"> -->
<!--             <pre class="" ng-bind-html="ctrl.jsonDisplayDataView"></pre> -->
<!--           </div> -->
<!--         </div> -->
<!--       </div> -->
<!--     </div> -->
<!--   </div> -->
<!-- </div> -->
<!-- <div class="modal-footer" uib-collapse="minimise"> -->
<!--   <button class="btn btn-warning btn-sm" type="button" ng-click="ctrl.cancel()">Cancel</button> -->
<!-- </div> -->

<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="container-fluid">
    <!-- Loader -->
    @if (showJsonLoader) {
<div class="viewBatchLoader">
      <i class="fa fa-spinner fa-spin fa-2x gt-refresh"></i>
    </div>
}

    @if (!showJsonLoader) {
<div>
      @if (showJSON) {
<div class="jsonContainer">
        <div class="old old_diff_block">JSON Data</div>
        <div class="jsonScrollContainer">
          <pre class="json-pre-view" [innerHTML]="jsonDisplayDataView"></pre>
        </div>
      </div>
}
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
